import {
  AnyAction,
  PayloadAction,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { StudentDetailsDTO, StudentInitialStateDTO } from "./types";
import {
  GetStudentByInstituteIdRequest,
  OpenSearchStudentListing,
} from "./student.request";

export const initialState: StudentInitialStateDTO = {
  error: false,
  success: false,
  loading: false,
  studentDetails: null,
  studentListLoading: false,
};

export const getStudentByInstituteId = createAsyncThunk(
  "/student/instituteId",
  async (
    data: {
      id: string;
      lastEvaluatedKey: string;
      limit: number;
      lastEvaluatedSortKey: string;
      branchId: string;
      assigneeId: string;
    },
    thunkAPI: any
  ) => {
    const {
      id,
      lastEvaluatedKey,
      limit,
      lastEvaluatedSortKey,
      branchId,
      assigneeId,
    } = data;

    return GetStudentByInstituteIdRequest(
      id,
      lastEvaluatedKey,
      limit,
      lastEvaluatedSortKey,
      branchId,
      assigneeId
    )
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const openSearchStudentListing = createAsyncThunk(
  "/student/openSearch/instituteId",
  async (data: any) => {
    return OpenSearchStudentListing(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    reset: () => initialState,
    resetStudentDetails: (state) => {
      state.studentDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(openSearchStudentListing.pending, (state) => {
      state.studentListLoading = true;
      state.error = false;
    });
    builder.addCase(
      openSearchStudentListing.fulfilled,
      (state, action: PayloadAction<StudentDetailsDTO>) => {
        state.studentListLoading = false;
        state.error = false;
        state.studentDetails = action?.payload;
      }
    );
    builder.addCase(
      openSearchStudentListing.rejected,
      (state, action: AnyAction) => {
        state.studentListLoading = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
  },
});

export default studentSlice.reducer;
export const { resetStudentDetails } = studentSlice.actions;
